import React, { Suspense, lazy } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Login from "./components/Login";
import Body from "./components/Body";
import ProtectedRoute from "./components/ProtectedRoute";
import { AuthProvider, useAuthProvider } from "./customHooks/authContext";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./App.css";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Eventos = lazy(() => import("./components/Events/Events.js"));
const Members = lazy(() => import("./components/Members/Members"));
const Users = lazy(() => import("./components/Users/Users.js"));
const Schools = lazy(() => import("./components/Schools/Schools.js"));
const EventTable = lazy(() => import("./components/Events/EventsTable"));
const EventEdit = lazy(() => import("./components/Events/EventEdit"));
const Registration = lazy(() => import("./components/Registrations/Registration"));
const Performances = lazy(() => import("./components/performance/Performances.js"));
const Courses = lazy(() => import("./components/Courses/Courses.js"));
const Payments = lazy(() => import("./components/Payments/Payments.js"));
const Modalities = lazy(() => import("./components/Settings/Modalities.js"));
const Forms = lazy(() => import("./components/Settings/Forms.js"));
const Registrations = lazy(() => import("./components/EventOrganization/Registrations.js"));
const PerformancesOrder = lazy(() => import("./components/EventOrganization/performanceOrder/PerformancesOrder.js"));
const Credentials = lazy(() => import("./components/EventOrganization/Credentials.js"));
const Accreditations = lazy(() => import("./components/EventOrganization/Accreditations.js"));
const Reports = lazy(() => import("./components/EventOrganization/Reports.js"));
const ManagementPerformances = lazy(() => import("./components/EventOrganization/ManagementPerformances.js"));
const AwardAllocation = lazy(() => import("./components/SettingsAward/AwardAllocation.js"));
const PrizeCalculator = lazy(() => import("./components/SettingsAward/PrizeCalculator.js"));
const AwardConsultation = lazy(() => import("./components/SettingsAward/AwardConsultation.js"));
const ManagementPayments = lazy(() => import("./components/Payments/ManagementPayments.js"));
const CoursesAdm = lazy(() => import("./components/Courses/CoursesAdm.js"));
const CoursesParticipants = lazy(() => import("./components/Courses/CoursesParticipants.js"));
const CoursesParticipantsEdit = lazy(() => import("./components/Courses/CoursesParticipantsEdit.js"));
const FinancialMovements = lazy(() => import("./components/Payments/FinancialMovements.js"));
const Certificates = lazy(() => import("./components/Certificates/Certificates.js"));
const Teachers = lazy(() => import("./components/Teachers/Teachers.js"));

function AppContent() {
  const { isAuthenticated, role } = useAuthProvider();

  return (
    <Router>
      <Suspense fallback={<div className="text-center p-4">Cargando...</div>}>
      <Routes>
        {/* Redirección raíz según el rol */}
        <Route
  path="/"
  element={
    isAuthenticated ? (
      role.includes("Administrador") || role.includes("Operador") ? (
        <Navigate to="/events" replace />
      ) : role.includes("Escuela") ? (
        <Navigate to="/obras" replace />
      ) : (
        <Navigate to="/members" replace />
      )
    ) : (
      <Navigate to="/login" replace />
    )
  }
/>


        {/* Ruta pública de Login */}
        <Route path="/login" element={isAuthenticated ? <Navigate to="/" replace /> : <Login />} />

        {/* Rutas protegidas normales */}
        <Route
          path="/members"
          element={
            <ProtectedRoute>
              <Body>
                <Members />
              </Body>
            </ProtectedRoute>
          }
        />
        <Route
          path="/registration"
          element={
            <ProtectedRoute>
              <Body>
                <Registration />
              </Body>
            </ProtectedRoute>
          }
        />
        <Route
          path="/performance"
          element={
            <ProtectedRoute>
              <Body>
                <Performances />
              </Body>
            </ProtectedRoute>
          }
        />
        <Route
          path="/course"
          element={
            <ProtectedRoute>
              <Body>
                <Courses/>
              </Body>
            </ProtectedRoute>
          }
        />
        <Route
          path="/payments"
          element={
            <ProtectedRoute>
              <Body>
                <Payments/>
              </Body>
            </ProtectedRoute>
          }
        />
        <Route
          path="/certificates"
          element={
            <ProtectedRoute>
              <Body>
                <Certificates/>
              </Body>
            </ProtectedRoute>
          }
        />

        {/* Rutas solo para administradores */}
         <Route path="/events" element={
          <ProtectedRoute allowedRoles={["Administrador", "Operador"]}>
            <Body><Eventos /></Body>
          </ProtectedRoute>
        } />
        
        <Route
          path="/settings/modalities"
          element={
            <ProtectedRoute adminOnly operatorOnly>
              <Body>
                <Modalities />
              </Body>
            </ProtectedRoute>
          }
        />
        <Route
          path="/settings/forms"
          element={
            <ProtectedRoute adminOnly operatorOnly>
              <Body>
                <Forms />
              </Body>
            </ProtectedRoute>
          }
        />
        <Route
          path="/teachers"
          element={
            <ProtectedRoute allowedRoles={["Operador"]}>
              <Body>
                <Teachers />
              </Body>
            </ProtectedRoute>
          }
        />
        <Route
          path="/users"
          element={
            <ProtectedRoute adminOnly operatorOnly>
              <Body>
                <Users />
              </Body>
            </ProtectedRoute>
          }
        />
        <Route
          path="/eventorganization/registrations"
          element={
            <ProtectedRoute adminOnly operatorOnly>
              <Body>
                <Registrations />
              </Body>
            </ProtectedRoute>
          }
        />
        <Route
          path="/eventorganization/performancesorder"
          element={
            <ProtectedRoute adminOnly operatorOnly>
              <Body>
                <PerformancesOrder />
              </Body>
            </ProtectedRoute>
          }
        />
        <Route
          path="/eventorganization/credentials"
          element={
            <ProtectedRoute adminOnly operatorOnly>
              <Body>
                <Credentials />
              </Body>
            </ProtectedRoute>
          }
        />
        <Route
          path="/eventorganization/accreditations"
          element={
            <ProtectedRoute adminOnly operatorOnly>
              <Body>
                <Accreditations />
              </Body>
            </ProtectedRoute>
          }
        />
        <Route
          path="/eventorganization/reports"
          element={
            <ProtectedRoute adminOnly operatorOnly>
              <Body>
                <Reports />
              </Body>
            </ProtectedRoute>
          }
        />
        <Route
          path="/eventorganization/managementperformances"
          element={
            <ProtectedRoute adminOnly operatorOnly>
              <Body>
                <ManagementPerformances />
              </Body>
            </ProtectedRoute>
          }
        />
        <Route
          path="/courses/coursesadm"
          element={
            <ProtectedRoute adminOnly operatorOnly>
              <Body>
                <CoursesAdm />
              </Body>
            </ProtectedRoute>
          }
        />
        <Route
          path="/courses/coursesparticipantsedit"
          element={
            <ProtectedRoute adminOnly operatorOnly>
              <Body>
                <CoursesParticipantsEdit />
              </Body>
            </ProtectedRoute>
          }
        />
        <Route
          path="/settingsaward/awardallocation"
          element={
            <ProtectedRoute adminOnly>
              <Body>
                <AwardAllocation />
              </Body>
            </ProtectedRoute>
          }
        />
        <Route
          path="/settingsaward/prizecalculator"
          element={
            <ProtectedRoute adminOnly>
              <Body>
                <PrizeCalculator />
              </Body>
            </ProtectedRoute>
          }
        />
        <Route
          path="/settingsaward/awardconsultation"
          element={
            <ProtectedRoute adminOnly>
              <Body>
                <AwardConsultation />
              </Body>
            </ProtectedRoute>
          }
        />
        <Route
          path="/payments/managementpayments"
          element={
            <ProtectedRoute adminOnly>
              <Body>
                <ManagementPayments />
              </Body>
            </ProtectedRoute>
          }
        />
        <Route
          path="/payments/financialmovements"
          element={
            <ProtectedRoute adminOnly>
              <Body>
                <FinancialMovements />
              </Body>
            </ProtectedRoute>
          }
        />
        <Route
          path="/schools"
          element={
            <ProtectedRoute adminOnly>
              <Body>
                <Schools />
              </Body>
            </ProtectedRoute>
          }
        />
        <Route
          path="/members"
          element={
            <ProtectedRoute adminOnly>
              <Body>
                <Members />
              </Body>
            </ProtectedRoute>
          }
        />
        <Route
          path="/courses/coursesparticipants"
          element={
            <ProtectedRoute>
              <Body>
                <CoursesParticipants/>
              </Body>
            </ProtectedRoute>
          }
        />



                {/* Rutas solo para escuelas */}
                <Route
          path="/obras"
          element={
            <ProtectedRoute schoolOnly>
              <Body>
                <EventTable />
              </Body>
            </ProtectedRoute>
          }/>

        {/* Edición de eventos */}
        <Route
          path="/edit-event/:id"
          element={
            <ProtectedRoute>
              <Body>
                <EventEdit />
              </Body>
            </ProtectedRoute>
          }
        />

        {/* Ruta por defecto si no coincide ninguna */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      </Suspense>
    </Router>
  );
}
function App() {
  return (
    <AuthProvider>
      <AppContent />
       <ToastContainer 
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
    </AuthProvider>
  );
}

export default App;
